module.exports = __webpack_public_path__ + "img/T25.7165d1ee.jpeg";